/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  OTP_AUTH_TOKEN_EMAIL_KEY,
  OTP_AUTH_TOKEN_MOBILE_KEY,
} from '../constants/otpStorageKeys';

export const otpTokenStore = {
  setMobile: (token: string): Promise<void> =>
    AsyncStorage.setItem(OTP_AUTH_TOKEN_MOBILE_KEY, token),

  setEmail: (token: string): Promise<void> =>
    AsyncStorage.setItem(OTP_AUTH_TOKEN_EMAIL_KEY, token),

  getEmail: async (): Promise<string> =>
    (await AsyncStorage.getItem(OTP_AUTH_TOKEN_EMAIL_KEY)) || '',

  removeEmail: (): Promise<void> =>
    AsyncStorage.removeItem(OTP_AUTH_TOKEN_EMAIL_KEY),
};
